//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import UserSelect from '~/components/UserSelect.vue';
import constant from '~/const';

export default {
  components: { UserSelect },

  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      input: {},
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),

    isCreating() {
      return Object.values(this.$props.data).length === 0;
    },

    userModel: {
      get() {
        return this.input.user;
      },
      set(value) {
        this.input.user = value;
      },
    },

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),

    async action() {
      const { input } = this;
      const { data } = this.$props;
      const payload = {};

      if (this.isCreating) {
        payload.leadId = this.$route.params.id;
        payload.traderId = input.user.id;
      } else {
        payload.id = data.id;
      }

      payload.payInPercentage = input.payInPercentage;
      payload.payOutPercentage = input.payOutPercentage;

      this.$emit('action', payload);
      this.input = {};
    },
  },
};
